module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_hardangled.68176a2e.png";